// extracted by mini-css-extract-plugin
export default {"Nav":"navbar_Nav__+52tR","Navlink":"navbar_Navlink__lbuNG"};